import { FC } from 'react';
import '../styles.scss';

const TombalaFrame: FC<FrameTypes> = ({ iframeSrc, iframeId, iframeClasses }) => {
  return <iframe className={iframeClasses} id={iframeId} src={iframeSrc.loggedIn} allowFullScreen></iframe>;
};

export default TombalaFrame;
